import React from 'react'
import { SupportPlayer, supportPlayerName } from '../../hooks/supportplayer/useOrgSupportPlayers'
import { IRecruiter } from './CampaignTable'

interface RecruitedSupportersRowProps {
  recruiter: IRecruiter
  supportersById: Map<string, SupportPlayer>
  colSpan: number
}

// Expanded row listing which supporters are registered under a participant
const RecruitedSupportersRow: React.FC<RecruitedSupportersRowProps> = ({
  recruiter,
  supportersById,
  colSpan,
}) => {
  const recruitedUsers = recruiter.recruited_users.filter((r) => !!r.user_id)

  return (
    <tr className='bg-light'>
      <td colSpan={colSpan} className='ps-10 py-3'>
        {recruitedUsers.length === 0 ? (
          <span className='text-muted fs-7'>Ingen støttespillere på denne deltageren ennå</span>
        ) : (
          <table className='table table-sm mb-0 gs-0 gy-1'>
            <thead>
              <tr className='fw-bold text-muted fs-8'>
                <th className='text-uppercase'>Støttespiller</th>
                <th className='text-uppercase'>E-post</th>
                <th className='text-uppercase'>Registrert</th>
                <th className='text-uppercase'>Motatt støtte</th>
              </tr>
            </thead>
            <tbody>
              {recruitedUsers.map((recruitedUser, index) => {
                const supporter = supportersById.get(recruitedUser.user_id)
                return (
                  // A supporter can be registered twice under the same participant
                  // eslint-disable-next-line react/no-array-index-key
                  <tr key={`${recruitedUser.user_id}-${index}`} className='fs-7'>
                    <td className='text-dark fw-bold'>
                      {supportPlayerName(supporter) || 'Ukjent støttespiller'}
                    </td>
                    <td className='text-muted'>{supporter?.email || '-'}</td>
                    <td className='text-muted'>
                      {recruitedUser.recruited_on
                        ? new Date(recruitedUser.recruited_on).toLocaleDateString('nb-NO')
                        : '-'}
                    </td>
                    <td className='text-muted'>{recruitedUser.total_amount || 0}</td>
                  </tr>
                )
              })}
            </tbody>
          </table>
        )}
      </td>
    </tr>
  )
}

export default React.memo(RecruitedSupportersRow)
